<template>
  <div>
    <div
      v-for="(value, key) in filing"
      :key="key"
    >
      <b>{{ key }}</b>: &nbsp; {{ value }}<br>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  computed: {
    filing () {
      const filing = this.$store.getters[ 'filings/filingById' ](this.$route.params.filingId);
      if (filing) {
        return filing[0];
      }
      return {};
    },
  },
  async mounted () {
    await this.initialFetch();
    await this.initialAssign();
    this.$store.commit('loading', false);
  },
  methods: {
    async initialFetch () {
      let promises = [];
      promises.push(this.$store.dispatch('filings/fetchUserFilings', this.$route.params.userId));
      promises.push(this.$store.dispatch('user/fetchUserProfile', this.$route.params.userId));
      await Promise.all(promises);
    },
    initialAssign () {

    },
  },
};
</script>